import { Observable } from 'rxjs';
import { GGFaqsAI, GGSapIdWSDTO } from '../../components/gg-ai-troubleshoot/gg-ai-troubleshoot.component';

export abstract class GgAiTroubleshootAdapter {
  abstract getSapIdFromAuidOrSn(auidOrSn: string): Observable<GGSapIdWSDTO>;
  abstract getFaqsAI(auidOrSn: string, issueDescription: string): Observable<GGFaqsAI>;
}
